import { __assign, __spreadArrays } from "tslib";
import * as _ from 'lodash';
import { FieldValueType, FieldActions, FieldActionType, } from '../Fields';
import { isEmailValid, cleanListOnlyActions } from './misc.utils';
import { Contact, ContactNameDTO, ContactEmailDTO, ContactPhoneDTO, ContactAddressDTO, ContactUrlDTO, ContactDateDTO, ContactCustomFieldType, } from '../../../types';
import { allowedRequiredFields } from '../config';
export var ValidationErrorTypes;
(function (ValidationErrorTypes) {
    ValidationErrorTypes["INVALID_EMAIL"] = "INVALID_EMAIL";
    ValidationErrorTypes["EMPTY_REQUIRED_FIELD"] = "EMPTY_REQUIRED_FIELD";
    ValidationErrorTypes["DUPLICATE_EMAIL"] = "DUPLICATE_EMAIL";
})(ValidationErrorTypes || (ValidationErrorTypes = {}));
export var isRequiredFieldValid = function (field) {
    switch (field.type) {
        case FieldValueType.EMAIL:
            return field.value.email.length !== 0;
        default:
            return true;
    }
};
export var validateFields = function (fields, initialRequiredFields) {
    var requiredFields = [];
    if (initialRequiredFields && initialRequiredFields.length) {
        requiredFields = __spreadArrays(initialRequiredFields);
    }
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var f = fields_1[_i];
        if (f.isBuildInField) {
            if (requiredFields.includes(f.id)) {
                if (allowedRequiredFields.includes(f.id)) {
                    if (!isRequiredFieldValid(f)) {
                        return {
                            type: ValidationErrorTypes.EMPTY_REQUIRED_FIELD,
                            field: f,
                        };
                    }
                }
                else {
                    console.warn(f.id + " is not allowed to be a required field! please speak with contacts team to whitelist it");
                }
            }
            switch (f.type) {
                case FieldValueType.EMAIL:
                    var emailValue = f.value.email;
                    if (emailValue && !isEmailValid(emailValue)) {
                        return {
                            type: ValidationErrorTypes.INVALID_EMAIL,
                            field: f,
                        };
                    }
                    break;
                default:
            }
        }
    }
    return null;
};
export var convertFieldsToContact = function (originalContact, fields) {
    var newLabels = [];
    var contact = originalContact ? __assign({}, originalContact) : new Contact();
    if (originalContact && originalContact.id) {
        contact.id = originalContact.id;
    }
    contact.emails.length = 0;
    contact.phones.length = 0;
    contact.addresses.length = 0;
    contact.dates.length = 0;
    contact.urls.length = 0;
    contact.customFields.length = 0;
    for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
        var f = fields_2[_i];
        if (f.isBuildInField) {
            switch (f.type) {
                case FieldValueType.NAME:
                    contact.name = contact.name || new ContactNameDTO();
                    contact.name.first = f.value.first || '';
                    contact.name.last = f.value.last || '';
                    break;
                case FieldValueType.EMAIL:
                    var emailValue = f.value.email;
                    var email = new ContactEmailDTO();
                    email.email = emailValue || '';
                    email.emailStatus = f.value.emailStatus || '';
                    email.tag = f.value.tag || '';
                    contact.emails.push(email);
                    break;
                case FieldValueType.PHONE:
                    var phone = new ContactPhoneDTO();
                    phone.phone = f.value.phone || '';
                    phone.tag = f.value.tag || '';
                    contact.phones.push(phone);
                    break;
                case FieldValueType.ADDRESS:
                    var address = new ContactAddressDTO();
                    address.address = f.value.address || '';
                    address.city = f.value.city || '';
                    address.postalCode =
                        f.value.postalCode || '';
                    address.country = f.value.country || '';
                    address.tag = f.value.tag || '';
                    address.region = f.value.region || '';
                    contact.addresses.push(address);
                    break;
                case FieldValueType.WEBSITE:
                    var url = new ContactUrlDTO();
                    url.url = f.value.url;
                    url.tag = f.value.tag;
                    url.id = f.value.id;
                    contact.urls.push(url);
                    break;
                case FieldValueType.DATE:
                    var dateFieldValue = f.value;
                    if (!dateFieldValue.date) {
                        break;
                    }
                    var date = new ContactDateDTO();
                    date.tag = dateFieldValue.tag;
                    date.date = dateFieldValue.date;
                    contact.dates.push(date);
                    break;
                case FieldValueType.COMPANY:
                    var name_1 = f.value;
                    contact.company = __assign(__assign({}, contact.company), { name: name_1 });
                    break;
                case FieldValueType.POSITION:
                    var role = f.value;
                    contact.company = __assign(__assign({}, contact.company), { role: role });
                    break;
                case FieldValueType.VAT_ID:
                    var vatId = f.value;
                    contact.vatId = vatId;
                    break;
                case FieldValueType.BIRTHDAY:
                    var birthday = f.value;
                    contact.birthday = birthday;
                    break;
                case FieldValueType.LABELS:
                    var contactLabels = f.value;
                    contact.tags = contactLabels.labels;
                    newLabels = __spreadArrays(contactLabels.newLabels);
                    break;
                case FieldValueType.ASSIGNEES:
                    var assignee = f.value;
                    contact.assignees = assignee ? [assignee] : [];
                    break;
                default:
            }
        }
        else if (!f.isBuildInField) {
            contact.customFields.push({
                id: f.id,
                name: f.name,
                type: f.customFieldType,
                value: f.value,
            });
        }
    }
    return { contact: contact, newLabels: newLabels };
};
export var generateNewFields = function (contact, contactsEnableBirthdayField) {
    var contactHasCompanyName = Boolean(contact && contact.company && contact.company.name);
    var contactHasCompanyRole = Boolean(contact && contact.company && contact.company.role);
    var contactHasVatId = Boolean(contact && contact.vatId);
    var contactHasBirthday = Boolean(contact && contact.birthday);
    // TODO: make oject
    if (contactsEnableBirthdayField) {
        return [
            {
                name: 'email',
                type: FieldValueType.EMAIL,
                unique: false,
                isShown: true,
            },
            {
                name: 'phone',
                type: FieldValueType.PHONE,
                unique: false,
                isShown: true,
            },
            {
                name: 'address',
                type: FieldValueType.ADDRESS,
                unique: false,
                isShown: true,
            },
            {
                name: 'company.name',
                type: FieldValueType.COMPANY,
                unique: true,
                isShown: contactHasCompanyName ? false : true,
            },
            {
                name: 'company.role',
                type: FieldValueType.POSITION,
                unique: true,
                isShown: contactHasCompanyRole ? false : true,
            },
            {
                name: 'vatId',
                type: FieldValueType.VAT_ID,
                unique: true,
                isShown: contactHasVatId ? false : true,
            },
            {
                name: 'birthday',
                type: FieldValueType.BIRTHDAY,
                unique: true,
                isShown: contactHasBirthday ? false : true,
            },
        ];
    }
    return [
        {
            name: 'email',
            type: FieldValueType.EMAIL,
            unique: false,
            isShown: true,
        },
        {
            name: 'phone',
            type: FieldValueType.PHONE,
            unique: false,
            isShown: true,
        },
        {
            name: 'address',
            type: FieldValueType.ADDRESS,
            unique: false,
            isShown: true,
        },
        {
            name: 'company.name',
            type: FieldValueType.COMPANY,
            unique: true,
            isShown: contactHasCompanyName ? false : true,
        },
        {
            name: 'company.role',
            type: FieldValueType.POSITION,
            unique: true,
            isShown: contactHasCompanyRole ? false : true,
        },
        {
            name: 'vatId',
            type: FieldValueType.VAT_ID,
            unique: true,
            isShown: contactHasVatId ? false : true,
        },
        {
            name: 'date',
            type: FieldValueType.DATE,
            unique: false,
            isShown: true,
        },
        {
            name: 'website',
            type: FieldValueType.WEBSITE,
            unique: false,
            isShown: true,
        },
    ];
};
export var generateECNameField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.first, first = _c === void 0 ? '' : _c, _d = _b.last, last = _d === void 0 ? '' : _d;
    return ({
        id: 'name',
        type: FieldValueType.NAME,
        isBuildInField: true,
        value: {
            first: first,
            last: last,
        },
        order: 1,
    });
};
export var generateECEmailField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.email, email = _c === void 0 ? '' : _c, _d = _b.tag, tag = _d === void 0 ? '' : _d, _e = _b.emailStatus, emailStatus = _e === void 0 ? 'transactional' : _e, _f = _b.index, index = _f === void 0 ? 0 : _f, _g = _b.originalEmailStatus, originalEmailStatus = _g === void 0 ? 'transactional' : _g, _h = _b.isLoginEmail, isLoginEmail = _h === void 0 ? false : _h;
    return ({
        id: 'email',
        index: index,
        type: FieldValueType.EMAIL,
        list: 'emails',
        isBuildInField: true,
        tags: ['main', 'home', 'work'],
        value: {
            email: email,
            tag: tag,
            emailStatus: emailStatus,
            originalEmailStatus: originalEmailStatus,
            isLoginEmail: isLoginEmail,
        },
        order: 50,
        actions: [FieldActions.ADD, FieldActions.REMOVE],
    });
};
export var generateECPhoneField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.phone, phone = _c === void 0 ? '' : _c, _d = _b.tag, tag = _d === void 0 ? '' : _d, _e = _b.index, index = _e === void 0 ? 0 : _e;
    return ({
        id: 'phone',
        index: index,
        type: FieldValueType.PHONE,
        list: 'phones',
        isBuildInField: true,
        tags: ['main', 'home', 'mobile', 'work', 'fax'],
        value: {
            phone: phone,
            tag: tag,
        },
        order: 60,
        actions: [FieldActions.ADD, FieldActions.REMOVE],
    });
};
export var generateECAddressField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.address, address = _c === void 0 ? '' : _c, _d = _b.city, city = _d === void 0 ? '' : _d, _e = _b.postalCode, postalCode = _e === void 0 ? '' : _e, _f = _b.country, country = _f === void 0 ? '' : _f, _g = _b.region, region = _g === void 0 ? '' : _g, _h = _b.tag, tag = _h === void 0 ? '' : _h, _j = _b.index, index = _j === void 0 ? 0 : _j;
    return ({
        id: 'address',
        index: index,
        type: FieldValueType.ADDRESS,
        list: 'addresses',
        isBuildInField: true,
        tags: ['home', 'work', 'billing', 'shipping'],
        value: {
            address: address,
            tag: tag,
            city: city,
            postalCode: postalCode,
            country: country,
            region: region,
        },
        order: 70,
        actions: [FieldActions.ADD, FieldActions.REMOVE],
    });
};
export var generateECLabelField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.labels, labels = _c === void 0 ? [] : _c, _d = _b.newLabels, newLabels = _d === void 0 ? [] : _d;
    return ({
        id: 'label',
        type: FieldValueType.LABELS,
        isBuildInField: true,
        value: {
            labels: labels,
            newLabels: newLabels,
        },
        order: 110,
    });
};
export var generateECAssigneeField = function (value) {
    if (value === void 0) { value = ''; }
    return ({
        id: 'assignee',
        type: FieldValueType.ASSIGNEES,
        isBuildInField: true,
        value: value,
        order: 130,
    });
};
export var generateECCompanyField = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b;
    return ({
        id: 'company.name',
        type: FieldValueType.COMPANY,
        isBuildInField: true,
        value: value,
        order: 20,
        actions: [FieldActions.REMOVE],
    });
};
export var generateECPositionField = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b;
    return ({
        id: 'company.role',
        type: FieldValueType.POSITION,
        isBuildInField: true,
        value: value,
        order: 30,
        actions: [FieldActions.REMOVE],
    });
};
export var generateECVatIdField = function (_a) {
    var _b = (_a === void 0 ? {} : _a).value, value = _b === void 0 ? '' : _b;
    return ({
        id: 'vatId',
        type: FieldValueType.VAT_ID,
        isBuildInField: true,
        vatId: value,
        value: value,
        order: 120,
        actions: [FieldActions.REMOVE],
        isRemovable: true,
    });
};
export var generateECBirthdayField = function (_a) {
    var _b = (_a === void 0 ? {} : _a).value, value = _b === void 0 ? '' : _b;
    return ({
        id: 'birthday',
        type: FieldValueType.BIRTHDAY,
        isBuildInField: true,
        value: value,
        order: 75,
        actions: [FieldActions.REMOVE],
        isRemovable: true,
    });
};
export var generateECWebsiteField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.url, url = _c === void 0 ? '' : _c, _d = _b.id, id = _d === void 0 ? 1 : _d, _e = _b.tag, tag = _e === void 0 ? '' : _e, _f = _b.index, index = _f === void 0 ? 0 : _f;
    return ({
        id: 'urls',
        index: index,
        type: FieldValueType.WEBSITE,
        list: 'urls',
        isBuildInField: true,
        tags: ['company', 'personal'],
        value: {
            id: id,
            tag: tag,
            url: url,
        },
        order: 100,
        actions: [FieldActions.ADD, FieldActions.REMOVE],
        isRemovable: true,
    });
};
export var generateECDateField = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.date, date = _c === void 0 ? '' : _c, _d = _b.id, id = _d === void 0 ? 1 : _d, _e = _b.tag, tag = _e === void 0 ? '' : _e, _f = _b.index, index = _f === void 0 ? 0 : _f;
    return ({
        id: 'dates',
        index: index,
        type: FieldValueType.DATE,
        list: 'dates',
        isBuildInField: true,
        tags: ['birthday', 'anniversary'],
        value: {
            id: id,
            tag: tag,
            date: date,
        },
        order: 90,
        actions: [FieldActions.ADD, FieldActions.REMOVE],
        isRemovable: true,
    });
};
export var getCustomFieldValue = function (id, contact) {
    if (contact && contact.customFields) {
        var contactCF = contact.customFields.find(function (customField) { return customField.id === id; });
        return contactCF ? contactCF.value : null;
    }
    return null;
};
export var generateECCustomField = function (id, name, value, customFieldType) {
    if (id === void 0) { id = ''; }
    if (name === void 0) { name = ''; }
    if (value === void 0) { value = ''; }
    if (customFieldType === void 0) { customFieldType = ContactCustomFieldType.Text; }
    return ({
        id: id,
        type: FieldValueType.CUSTOM,
        isBuildInField: false,
        customFieldType: customFieldType,
        name: name,
        value: value,
        order: 200,
        actions: [FieldActions.RENAME],
    });
};
export var updateCustomFields = function (fields, customFields) {
    if (fields === void 0) { fields = []; }
    if (customFields === void 0) { customFields = []; }
    var newCustomFields = [];
    var newECFields = [];
    customFields.forEach(function (customField) {
        var fieldIndex = fields.findIndex(function (field) { return field.id === customField.id; });
        if (fieldIndex === -1) {
            newCustomFields.push(customField);
        }
        else if (!fields[fieldIndex].isBuildInField) {
            fields[fieldIndex].name = customField.name;
        }
    });
    newCustomFields.forEach(function (newCustomField) {
        var newECField = generateECCustomField(newCustomField.id, newCustomField.name, (newCustomField.value = null), newCustomField.type);
        newECFields.push(newECField);
        fields.push(newECField);
    });
    return { fields: __spreadArrays(fields), newFields: newECFields };
};
export var generateContactFromPrefilledFields = function (prefilledFields) {
    var contact = new Contact();
    contact = _.assign(contact, prefilledFields);
    return contact;
};
export var convertContactToFields = function (contact, customFields, prefilledContact, contactsEnableBirthdayField) {
    if (customFields === void 0) { customFields = []; }
    if (!contact) {
        if (prefilledContact) {
            contact = generateContactFromPrefilledFields(prefilledContact);
        }
        else {
            contact = new Contact();
        }
    }
    var fields = [];
    fields.push(generateECNameField({
        first: (contact.name && contact.name.first) || '',
        last: (contact.name && contact.name.last) || '',
    }));
    if (contact.company && contact.company.name) {
        fields.push(generateECCompanyField({ value: contact.company.name }));
    }
    if (contact.company && contact.company.role) {
        fields.push(generateECPositionField({ value: contact.company.role }));
    }
    if (contact.vatId) {
        fields.push(generateECVatIdField({ value: contact.vatId }));
    }
    if (contact.emails && contact.emails.length) {
        contact.emails.forEach(function (email, index) {
            fields.push(generateECEmailField({
                index: index,
                email: email.email,
                tag: email.tag,
                emailStatus: email.emailStatus,
                originalEmailStatus: email.emailStatus,
                isLoginEmail: email.isLoginEmail,
            }));
        });
    }
    else {
        fields.push(generateECEmailField());
    }
    if (contact.phones && contact.phones.length) {
        contact.phones.forEach(function (phone, index) {
            fields.push(generateECPhoneField(__assign(__assign({}, phone), { index: index })));
        });
    }
    else {
        fields.push(generateECPhoneField());
    }
    if (contact.addresses && contact.addresses.length) {
        contact.addresses.forEach(function (address, index) {
            fields.push(generateECAddressField(__assign(__assign({}, address), { index: index })));
        });
    }
    else {
        fields.push(generateECAddressField());
    }
    if (contactsEnableBirthdayField) {
        if (contact.birthday) {
            fields.push(generateECBirthdayField({ value: contact.birthday }));
        }
    }
    else {
        if (contact.dates && contact.dates.length) {
            contact.dates.forEach(function (date, index) {
                fields.push(generateECDateField(__assign(__assign({}, date), { index: index })));
            });
        }
        if (contact.urls && contact.urls.length) {
            contact.urls.forEach(function (url, index) {
                fields.push(generateECWebsiteField(__assign(__assign({}, url), { index: index })));
            });
        }
    }
    fields.push(generateECLabelField({ labels: contact.tags, newLabels: [] }));
    if (contact.assignees && contact.assignees.length) {
        fields.push(generateECAssigneeField(contact.assignees[0]));
    }
    else {
        fields.push(generateECAssigneeField());
    }
    customFields.forEach(function (customField) {
        fields.push(generateECCustomField(customField.id, customField.name, (customField.value = getCustomFieldValue(customField.id, contact)), customField.type));
    });
    return fields.sort(function (a, b) { return a.order - b.order; });
};
export var fieldTypeToGenerateFunction = new Map([
    [FieldValueType.EMAIL, generateECEmailField],
    [FieldValueType.PHONE, generateECPhoneField],
    [FieldValueType.ADDRESS, generateECAddressField],
    [FieldValueType.COMPANY, generateECCompanyField],
    [FieldValueType.POSITION, generateECPositionField],
    [FieldValueType.VAT_ID, generateECVatIdField],
    [FieldValueType.DATE, generateECDateField],
    [FieldValueType.WEBSITE, generateECWebsiteField],
    [FieldValueType.BIRTHDAY, generateECBirthdayField],
]);
export var transformEmailFieldActions = function (field, actions) {
    var value = field.value;
    if (value.isLoginEmail) {
        return actions.filter(function (a) { return a.name !== FieldActionType.REMOVE; });
    }
    return actions;
};
export var getActionsForField = function (field, fieldList) {
    var actions = field.actions;
    var isFieldPartOfList = 'index' in field;
    var isFieldAloneInList = fieldList.filter(function (fieldInList) { return fieldInList.id === field.id; }).length === 1;
    if (isFieldPartOfList && isFieldAloneInList) {
        actions = cleanListOnlyActions(actions);
    }
    if (field.type === FieldValueType.EMAIL) {
        actions = transformEmailFieldActions(field, actions);
    }
    return actions;
};
export var handleAddField = function (field, fieldList, newFieldsList) {
    var fields = __spreadArrays(fieldList);
    var indexToSet = 0;
    var fieldsByType = fields.filter(function (f) { return f.type === field.type; });
    if (fieldsByType.length && fieldsByType[0].list) {
        var latestField = _.maxBy(fieldsByType, function (f) { return f.index; });
        indexToSet = latestField.index + 1;
    }
    var newField = fieldTypeToGenerateFunction.get(field.type)({
        index: indexToSet,
    });
    var newFieldsArray = fields.concat([newField]);
    newFieldsArray.sort(function (a, b) { return a.order - b.order; });
    if (field.unique) {
        var newFields = __spreadArrays(newFieldsList);
        var newFieldIndex = newFields.findIndex(function (f) { return f.type === field.type; });
        newFields[newFieldIndex].isShown = false;
        return { fields: newFieldsArray, newFields: newFields, newField: newField };
    }
    return { fields: newFieldsArray, newField: newField };
};
export var handleRemoveField = function (field, fields, newFields) {
    var updatedFields = __spreadArrays(fields);
    var updatedNewFields = __spreadArrays(newFields);
    var fieldIndex = getFieldIndex(field, fields);
    updatedFields.splice(fieldIndex, 1);
    var fieldInNewFieldsIndex = updatedNewFields.findIndex(function (f) { return f.type === field.type && f.unique; });
    if (fieldInNewFieldsIndex !== -1) {
        updatedNewFields[fieldInNewFieldsIndex].isShown = true;
    }
    return {
        fields: updatedFields,
        newFields: updatedNewFields,
    };
};
export var getFieldIndex = function (field, fieldList) {
    if (field.list) {
        return fieldList.findIndex(function (f) {
            return f.id === field.id &&
                f.index === field.index;
        });
    }
    return fieldList.findIndex(function (f) { return f.id === field.id; });
};
//# sourceMappingURL=FieldList.utils.js.map